




export const baseUrl = process.env.NEXT_PUBLIC_API_URL || "http://localhost:5000/api/v1";
export const imageUrl = process.env.NEXT_PUBLIC_IMAGE_URL || "http://localhost:5000";




// export const baseUrl = process.env.NEXT_PUBLIC_API_URL || "https://hubmicroo.hubmicroo.com/api/v1";
// export const imageUrl = process.env.NEXT_PUBLIC_IMAGE_URL || "https://hubmicroo.hubmicroo.com";